import { Button, Modal } from "react-bootstrap";
import { UserCurrency } from "../types";
import { QRCodeSVG } from "qrcode.react";
import { getIconFromName } from "../../../util/Icons";

interface UserCurrencyModalProps {
  userCurrency: UserCurrency;
  show: boolean;
  onHide: Function;
}

export function UserCurrencyModal(props: UserCurrencyModalProps) {
  if (!props.userCurrency) return <></>;
  var currencyName = props.userCurrency.currency.name;
  return (
    <Modal show={props.show} onHide={() => props.onHide()}>
      <Modal.Header closeButton>
        <Modal.Title>
          {currencyName} {getIconFromName(currencyName)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Current Balance</h4>
        <p>{props.userCurrency.amount} eth</p>
        <h4>Deposit</h4>
        <QRCodeSVG
          value={props.userCurrency.address}
          style={{ margin: "0 auto", width: "100%" }}
        />
        <p style={{ textAlign: "center" }}>{props.userCurrency.address}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.onHide()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
